import {EndPoints} from '../api-config';
let SERVER_ADDR_V1 = EndPoints.backendHost;
export const getAuthenticationUrl = () => {
    localStorage.removeItem("access_token");
    return '/auth/signin';
}
export const authenticationUrl = () => `${SERVER_ADDR_V1}/authentication/login`;
export const authenticationTwoFactorUrl = () => `${SERVER_ADDR_V1}/authentication/twoFactorAuthentication`;
export const registerUserUrl = () => `${SERVER_ADDR_V1}/user`;
export const resetPasswordEmail = () => `${SERVER_ADDR_V1}/user/resetPasswordEmail`;
export const setNewPassword = (id) => `${SERVER_ADDR_V1}/user/${id}/resetPassword`;
export const sendOTPUrl = () => `${SERVER_ADDR_V1}/sendPhoneNumberOTP`;
export const verifyOTPUrl = () => `${SERVER_ADDR_V1}/verifyPhoneNumberOTP`;